export default __webpack_public_path__ + "static/media/export.dff55950.svg";